// API base URL from env (CRA: REACT_APP_*).
// Local: blackbox_remasteredv2/.env → REACT_APP_API_URL=http://localhost:8080
// Production: leave unset — uses window.location.origin.

function trimUrl(url) {
  if (!url || typeof url !== 'string') return '';
  return url.trim().replace(/\/$/, '');
}

function resolveApiBaseUrl() {
  const fromEnv = trimUrl(process.env.REACT_APP_API_URL);
  if (fromEnv) return fromEnv;

  if (typeof window !== 'undefined' && window.location?.origin) {
    if (window.location.port === '3000') {
      return 'http://localhost:8080';
    }
    return window.location.origin;
  }

  return 'http://localhost:8080';
}

const config = {
  get apiBASEURL() {
    return resolveApiBaseUrl();
  },
};

export default config;
